import { render } from "./KeyboardF8.vue?vue&type=template&id=14df16d5"
import script from "./KeyboardF8.vue?vue&type=script&lang=js"
export * from "./KeyboardF8.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/KeyboardF8.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "14df16d5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('14df16d5', __exports__)) {
    api.reload('14df16d5', __exports__)
  }
  
  module.hot.accept("./KeyboardF8.vue?vue&type=template&id=14df16d5", () => {
    api.rerender('14df16d5', render)
  })

}


export default __exports__